import FAQ from "./pages/faq.page";
import Home from "./pages/home.page";
import About from "./pages/about.page";
import Team from "./pages/team.page";

const App = () => {
  return (
    <>
      <Home />
      <About />
      <Team />
      <FAQ />
    </>
  );
};

export default App;
